import React from 'react';
import { FaUser } from 'react-icons/fa';
import { useForm } from 'react-hook-form';
import { formatMonthYear } from '../../utils/funtions';
import MainLoader from '../Loaders/MainLoader';
import { useDispatch } from 'react-redux';
import { reservarCupoThunk, } from '../../store/slices/public/reservacionCupo.slice';
import iconStudent from '../../assets/icons/student.svg'

const CardStudent = ({ title, children, background, student, configuration, courses, }) => {

  const dispatch = useDispatch();
  const { setValue, register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = (data) => {
    data.grado = nextCourse?.name
    dispatch(reservarCupoThunk(student.id, data));
  };

  const nextCourse = courses.find((course) => course.level === (student.student?.course?.level + 1))

  return (
    <>
      {courses.length === 0 || !configuration ? (
        <MainLoader />
      ) : (
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={`${background} rounded-md border border-stroke px-7.5 shadow-sm shadow-slate-400 dark:border-strokedark dark:bg-boxdark`}>
          <div className='flex items-center gap-2 rounded-t-md bg-gradient-to-r from-p-green/90 to-green-500 py-2 px-4 text-sm text-white'>
            <img src={iconStudent} className='w-8 h-8' />
            <h1 className=' uppercase font-bold p-3 '> {title}</h1>
          </div>
          <div className="flex items-center justify-center dark:bg-meta-4">
            <div className='w-full h-full text-start '>
              <div className='flex gap-2 items-center justify-between p-2 bg-slate-200'>
                <p className='p-2'>Período actual</p>
                <p className='p-2'>{formatMonthYear(configuration?.fecha_inicio_periodo_actual) + ' - ' + formatMonthYear(configuration?.fecha_fin_periodo_actual)}</p>
              </div>
              <div className='flex gap-2 items-center justify-between p-2 bg-slate-100'>
                <p className='p-2'>Grado / Sección</p>
                <p className='p-2'>{student.student?.course?.name + ' ' + student.student?.parallel?.name}</p>
              </div>
              <div className='flex gap-2 items-center justify-between p-2 bg-slate-200'>
                <p className='p-2'>Siguiente nivel</p>
                <p className='p-2'>{nextCourse?.name}</p>
              </div>
              <div className='flex gap-2 items-center justify-between p-2 bg-slate-100'>
                <div className='flex flex-col p-2'>
                  <p>Reservar cupo ?</p>
                  <p>periodo {formatMonthYear(configuration?.fecha_inicio_periodo_siguiente) + ' - ' + formatMonthYear(configuration?.fecha_fin_periodo_siguiente)}</p>
                </div>
                {
                  student.cupo ? (
                    <p className='p-2'>{student.cupo?.reserva_cupo}</p>
                  ) : (
                    <select className='outline-none input-bordered focus:outline-none focus:ring-1 rounded-md shadow-base-400 shadow-md'
                      {...register("reservaCupo", { required: true })} >
                      <option value="SI">SI</option>
                      <option value="NO">NO</option>
                    </select>
                  )
                }

              </div>
              <div className='flex gap-2 items-center justify-between p-2 bg-slate-200'>
                <p className='p-2'>Alumno va a tomar el servicio de transporte?</p>
                {
                  student.cupo ? (
                    <p className='p-2'>{student.cupo?.servicio_transporte}</p>
                  ) : (
                    <select className='outline-none input-bordered focus:outline-none focus:ring-1 rounded-md shadow-base-400 shadow-md'
                      {...register("servicioTransporte", { required: true })} >
                      <option value="SI">SI</option>
                      <option value="NO">NO</option>
                    </select>
                  )
                }
              </div>
            </div>
          </div>
          {children}
        </form>
      )}
    </>
  );
};

export default CardStudent;
